import { api } from './api';

export default {
  apiTargetVersion: '1.74.2',
};

export const fetchConfig = (payload) => {
  return api.get('/organization/configuration', payload);
};

export const fetchUpdateConfigurations = (payload) => {
  return api.put('/organization/configuration', payload);
};
